import { ArticleImage, loadLargeImage } from '../articleImage';
import {
  accordionInit,
  contentListItemColor,
  fixFurtherContentHeadlineMargin,
  initModalRevealsForArticle,
  initTwoClickIframes
} from '../../articleHelper';
import ArticlePresenter from '../../articlePresenter';
import BackElement from '../backElement';
import CallToAction from '../callToAction';
import FormRenderer from '../forms/formRenderer';
import VideoRenderer from '../videos/videoRenderer';
import WidgetRenderer from '../widgets/widgetRenderer';
import React from 'react';
import $ from 'jquery';

class EventArticle extends React.Component {
  constructor() {
    super();
    this.state = {
      article: ArticlePresenter.nullArticle(),
      widgets: []
    };
  }

  componentDidMount() {
    this.ajaxArticle();
  }

  componentDidUpdate() {
    fixFurtherContentHeadlineMargin();
  }

  ajaxArticle() {
    const methods = [
      'selected_layout',
      'title',
      'content',
      'context_info',
      'call_to_action',
      'image_links_mobil_oben_content',
      'image_alt_links_mobil_oben',
      'image_links_mobil_unten_content',
      'image_alt_links_mobil_unten',
      'image_rechts_mobil_oben_content',
      'image_alt_rechts_mobil_oben',
      'image_rechts_mobil_unten_content',
      'image_alt_rechts_mobil_unten',
      'image_focus_hintergrund_mini',
      'image_focus_hintergrund_teaser',
      'image_focus_hintergrund_background',
      'event',
      'image_videovorschau_content',
      'image_alt_videovorschau',
      'vimeo_video',
      'youtube_video',
      'video_position',
      'widget_ids'
    ].join();

    $.ajax({
      url: `/api/v3/articles/${this.props.articleId}.json?methods=${methods}`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          this.setState({ article: ArticlePresenter.getArticle(data) }, function () {
            loadLargeImage(this);
            contentListItemColor();
            VideoRenderer.renderVideoModal(this.state.article.vimeoVideo);
            VideoRenderer.renderVideoModal(this.state.article.youtubeVideo);
            WidgetRenderer.widgetsForObject(this.state.article, (widgets) => {
              this.setState({ widgets }, () => {
                initModalRevealsForArticle(this.props.articleId);
                accordionInit();
                initTwoClickIframes();
              });
            });
          });
        }
      },
      error: (xhr, status, err) => console.error(this.props.articleId, status, err.toString())
    });
  }

  render() {
    const { article, widgets } = this.state;

    let layoutClass = '';

    if (article.layout === ArticlePresenter.ARTICLE_LAYOUTS.NUR_ZENTRIERTE_SPALTE) {
      layoutClass = 'centered-layout';
    }

    return (
      <div className="background-fixed" style={article.imageBackground}>
        <div className="container">
          <div className="row">
            <aside className="sidebar">&nbsp;</aside>

            <article className="content">
              <div className={`row ${layoutClass}`}>
                <BackElement />
              </div>

              <div className={`row ${layoutClass}`}>
                <MainContent article={article} widgets={widgets} />
                <FurtherContent article={article} widgets={widgets} />
              </div>
            </article>

            <aside className="spacebar">&nbsp;</aside>
          </div>
        </div>
      </div>
    );
  }
}

EventArticle.propTypes = {
  articleId: React.PropTypes.number
};

function MainContent({ article, widgets }) {
  function eventDate() {
    if (!article.event.event_date) {
      return null;
    }

    return <span className="color-secondary">{article.event.event_date.split('|').shift()}</span>;
  }

  function eventInfo() {
    if (
      !article.event.event_date &&
      !article.event.beginning &&
      !article.event.event_city &&
      !article.event.event_address
    ) {
      return null;
    }

    const eventDateTime = article.event.event_date.split('|');
    eventDateTime.shift(); // remove the data
    const eventTime = eventDateTime.join();

    return (
      <p>
        <i className="fa fa-calendar" /> {eventTime} {article.event.beginning}
        {(!!article.event.event_city || !!article.event.event_address) && <br />}
        {(!!article.event.event_city || !!article.event.event_address) && (
          <i className="fa fa-map-marker" style={{ fontSize: 18, marginLeft: 3, marginRight: 7 }} />
        )}
        {article.event.event_city}
        {article.event.event_address}
      </p>
    );
  }

  let gridClass = 'col-1-of-2';
  let vimeoVideo = null;
  let youtubeVideo = null;

  if (article.layout === ArticlePresenter.ARTICLE_LAYOUTS.NUR_ZENTRIERTE_SPALTE) {
    // only one column for centered column layout
    gridClass = 'col-1-of-1';
  }

  if (
    article.videoPosition.startsWith('left') ||
    article.layout === ArticlePresenter.ARTICLE_LAYOUTS.NUR_ZENTRIERTE_SPALTE
  ) {
    // render videos under main content if the video position is set to 'left_top' or 'left' or if
    // the centered column layout is selected, because there is no further content fot that case
    vimeoVideo = VideoRenderer.renderVideoImage(
      article.vimeoVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );
    youtubeVideo = VideoRenderer.renderVideoImage(
      article.youtubeVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );
  }

  return (
    <div className={`${gridClass} main-content content-lg`}>
      <h1 className="margin-bottom-xs">{article.title}</h1>
      {article.videoPosition === 'left_top' && (
        <div>
          {vimeoVideo}
          {youtubeVideo}
        </div>
      )}
      <div className="flex flex-row margin-bottom-xs">
        <div className="article-date">{eventDate()}</div>
        {WidgetRenderer.renderActionWidget('event', article)}
      </div>
      {eventInfo()}
      <ArticleImage imageUrl={article.imageLeftTopUrl} imageAlt={article.imageLeftTopAlt} />
      <div className="hidden-mobile">
        <ArticleImage imageUrl={article.imageLeftBottomUrl} imageAlt={article.imageLeftBottomAlt} />
      </div>
      <div className="hidden-desktop">
        <ArticleImage imageUrl={article.imageRightTopUrl} imageAlt={article.imageRightTopAlt} />
      </div>
      {WidgetRenderer.renderWidgets(widgets, 'before-main-content')}
      <div dangerouslySetInnerHTML={{ __html: article.mainContent }} />
      <CallToAction
        callToActionText={article.callToActionText}
        callToActionLink={article.callToActionLink}
      />
      {article.videoPosition === 'left' && (
        <div>
          {vimeoVideo}
          {youtubeVideo}
        </div>
      )}
      {WidgetRenderer.renderWidgets(widgets, 'main-content-before-form')}
      {FormRenderer.displayFor(article, 'main_content')}
      {FormRenderer.formInModal(article, 'modal_main_content')}
      {WidgetRenderer.renderWidgets(widgets, 'main-content')}
      <div className="hidden-desktop">
        <ArticleImage imageUrl={article.imageLeftBottomUrl} imageAlt={article.imageLeftBottomAlt} />
      </div>
    </div>
  );
}

MainContent.propTypes = {
  article: React.PropTypes.object,
  widgets: React.PropTypes.array
};

function FurtherContent({ article, widgets }) {
  if (article.layout === ArticlePresenter.ARTICLE_LAYOUTS.NUR_ZENTRIERTE_SPALTE) {
    return (
      <div className="col-1-of-1 further-content content-sm">
        <div dangerouslySetInnerHTML={{ __html: article.furtherContent }} />
        {WidgetRenderer.renderWidgets(widgets, 'further-content-before-form')}
        {FormRenderer.displayFor(article, 'further_content')}
        {FormRenderer.formInModal(article, 'modal')}
        {WidgetRenderer.renderWidgets(widgets, 'further-content')}
      </div>
    );
  }

  let vimeoVideo = null;
  let youtubeVideo = null;

  if (article.videoPosition === 'right') {
    // render videos in further content if the selected video position is 'right'
    vimeoVideo = VideoRenderer.renderVideoImage(
      article.vimeoVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );

    youtubeVideo = VideoRenderer.renderVideoImage(
      article.youtubeVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );
  }

  return (
    <div className="col-1-of-2 further-content content-sm">
      {vimeoVideo}
      {youtubeVideo}
      <div className="hidden-mobile">
        <ArticleImage imageUrl={article.imageRightTopUrl} imageAlt={article.imageRightTopAlt} />
      </div>
      <div className="hidden-mobile">
        <ArticleImage
          imageUrl={article.imageRightBottomUrl}
          imageAlt={article.imageRightBottomAlt}
        />
      </div>
      <div dangerouslySetInnerHTML={{ __html: article.furtherContent }} />
      {WidgetRenderer.renderWidgets(widgets, 'further-content-before-form')}
      {FormRenderer.displayFor(article, 'further_content')}
      {FormRenderer.formInModal(article, 'modal')}
      {WidgetRenderer.renderWidgets(widgets, 'further-content')}
      <div className="hidden-desktop">
        <ArticleImage
          imageUrl={article.imageRightBottomUrl}
          imageAlt={article.imageRightBottomAlt}
        />
      </div>
    </div>
  );
}

FurtherContent.propTypes = {
  article: React.PropTypes.object,
  widgets: React.PropTypes.array
};

export default EventArticle;



// WEBPACK FOOTER //
// ./components/articles/eventArticle.js